module.exports = __webpack_public_path__ + "static/media/Fontfabric - MullerUltraLight.d26f5bd6.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/Fontfabric - MullerUltraLight.otf
// module id = 1074
// module chunks = 0